"use client";

import { c as _c } from "react/compiler-runtime";
import type { ResolvedPromoRow } from "./types";
import { PromoContentBanner } from "./PromoContentBanner";
interface PromoSlotProps {
  row: ResolvedPromoRow | null;
  className?: string;
}

/**
 * Grid columns per row size. Container queries, not screen breakpoints: the
 * same position can sit full width, in a sidebar or in a half-width cell, and
 * the row should fit the space it is given. Three promos never wrap as 2 + 1.
 */
const ROW_GRID: Record<number, string> = {
  2: "@xl:grid-cols-2",
  3: "@4xl:grid-cols-3",
  4: "@xl:grid-cols-2"
};
export function PromoSlot(t0) {
  const $ = _c(13);
  const {
    row,
    className
  } = t0;
  if (!row || row.length === 0) {
    return null;
  }
  if (row.length === 1) {
    const [promo] = row;
    let t1;
    if ($[0] !== promo) {
      t1 = <PromoContentBanner promo={promo} displayMode={promo.displayMode} />;
      $[0] = promo;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== className || $[3] !== t1) {
      t2 = <div className={className}>{t1}</div>;
      $[2] = className;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  const t1 = `grid grid-cols-1 gap-4 ${ROW_GRID[row.length] ?? ROW_GRID[4]}`;
  let t2;
  if ($[5] !== row) {
    t2 = row.map(_temp);
    $[5] = row;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="@container"><div className={t1}>{t2}</div></div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== className || $[11] !== t3) {
    t4 = <div className={className}>{t3}</div>;
    $[10] = className;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(promo_0, i) {
  return <div key={i} className="h-full"><PromoContentBanner promo={promo_0} displayMode={promo_0.displayMode} fillHeight={true} /></div>;
}